import React from 'react';
import PropTypes from 'prop-types';
import PhotoModal from './PhotoModal';

const Photo = (props) => {
    const photo = props.photo;
    const [modalShow, setModalShow] = React.useState(false);

    return (
        <>
            <div className="photo">
                <div className="slide" onClick={() => setModalShow(true)}>
                    <p className="img-id">#{photo.id}
                    </p>
                    <img src={`${props.paths.cache}/${photo.id}_200w_L.jpg`} className="img-fluid" alt=""/>
                </div>
            </div>

            <PhotoModal photo={photo} show={modalShow} paths={props.paths} onHide={() => setModalShow(false)}
                options={props.options}/>
        </>
    );
};

Photo.propTypes = {
    photo: PropTypes.object,
    paths: PropTypes.object,
    onClick: PropTypes.func,
    options: PropTypes.object
};

export default Photo;
